import DepartmentsService from '@/services/DepartmentsService'

export default {
  state: {
    departments: [],
    currentDepartmentsCode: null
  },
  getters: {
    departments: state => state.departments,
    currentDepartmentsCode: state => state.currentDepartmentsCode
  },
  mutations: {
    setDepartments (state, data) {
      state.departments = data
    },
    setCurrentDepartmentsCode (state, data) {
      state.currentDepartmentsCode = data
    }
  },
  actions: {
    async loadDepartments ({ commit }, code) {
      const response = await DepartmentsService.getDepartmentsByCode(code)
      commit('setDepartments', response.departments)
      commit('setCurrentDepartmentsCode', code)
    }
  }
}
